<template>
  <!-- 机油滤清器 -->
  <div class="oil-filter-recommend">
    <!-- 机油滤清器产品基本信息 -->
    <div class="basic-info" v-if="basic_info_array.length > 0">
      <div class="sub-title">
        机油滤清器推荐<span>（{{ basic_info_array.length }}）</span>
      </div>
      <div
        :class="[
          'product-info',
          // { one: basic_info_array.length === 1 },
          // { two: basic_info_array.length === 2 },
          // { multiple: basic_info_array.length >= 3 },
        ]"
      >
        <div
          class="img-box"
          v-for="(item, index) in basic_info_array"
          :key="index"
          @click="selectInfo(index)"
        >
          <div
            :class="['inner-image', { 'active-box': index === activeIndex }]"
          >
            <!-- @click="preview(item.images)" -->
            <img class="show-img" :src="item.images[0]" alt="机油滤清器" />
          </div>
          <div class="right">
            <p :class="['name', { 'active-name': index === activeIndex }]">
              {{ item.brand_name }} {{ item.nick_name }}
            </p>
            <p :class="['spec', { 'active-name': index === activeIndex }]">
              {{ item.supplierCode }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 规格信息 -->
    <div class="spec-info" v-if="current_spec_info.length > 0">
      <div class="sub-title">规格信息</div>
      <div class="list">
        <div
          class="item"
          v-for="(item, index) in current_spec_info"
          :key="index"
        >
          <div class="title">{{ item.attrName }}</div>
          <div class="content">{{ item.attrValue }}</div>
        </div>
      </div>
    </div>
    <div
      class="all-empty"
      v-if="current_spec_info.length == 0 && basic_info_array.length == 0"
    >
      <div class="empty-box">
        <img
          src="https://select-oil-oss.vchangyi.com/wxapp/no-product-bg.png"
          class="empty-img"
          alt="empty"
        />
        <span>暂无产品推荐~</span>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/css/swiper.css";
import api from "@/apis/maintenance-api.js";
import { userQueryCarModelRecord } from "@/utils/data-burial";
import { setStatistics } from "@/utils/common";
import validToken from "@/mixins/valid-token.js";
export default {
  name: "OilFilterRecommend", //机油滤清器养护信息
  mixins: [validToken],
  props: {
    query: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      //滤清器数据（可能有多个供应商的情况）
      oil_filter_arrays: [
        // {
        //   basic_info: {
        //     //上方基本数据
        //     brand_name: "111", //品牌名
        //     nick_name: "222", //配件名
        //     images: [
        //       "https://z3.ax1x.com/2021/09/11/hz84K0.jpg",
        //       "https://z3.ax1x.com/2021/09/11/hz8R8s.jpg",
        //       "https://z3.ax1x.com/2021/09/11/hzMhJ1.jpg",
        //     ], //图片
        //     supplierCode: "243424", //供应商编码
        //   },
        //   spec_info: {}, //下方规格信息
        // },
      ],
      basic_info_array: [], //上方的基础信息数组
      current_spec_info: [], //当前选择的产品的规格数据
      activeIndex: 0,
      iswx: this.browser.wx, // 是否是微信环境，
      vehicle_id: "",
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  async mounted() {
    this.vehicle_ids = decodeURIComponent(this.query.vehicle_ids).split(","); //获取动态的参数
    this.dynamic_vehicle_ids_query = encodeURIComponent(
      this.vehicle_ids.join(",")
    );
    await this.fetchData(); //获取滤清器数据
    await this.queryDataRecord();
  },

  methods: {
    // 在用户切换轮播图时，同步切换下方对应数据
    onSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
      this.current_spec_info =
        this.oil_filter_arrays[this.activeIndex].spec_info;
    },
    selectInfo(index) {
      this.activeIndex = index;
      this.current_spec_info = this.oil_filter_arrays[index].spec_info;
    },
    // 获取滤清器数据
    async fetchData() {
      await this.fetchValidToken();
      if (!this.token) return;
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      let params = {
        parts_type: 4,
        vehicle_ids: this.vehicle_ids[0],
        iswx: this.iswx,
        token: this.token,
        scheme_id,
      };
      this.$loading.show("加载中...");
      try {
        // 优先取缓存数据
        let cacheDetail = null;
        const oilFilterCacheString = sessionStorage.getItem("oilFilterCache");
        if (
          oilFilterCacheString &&
          JSON.parse(oilFilterCacheString).key ===
            this.dynamic_vehicle_ids_query
        ) {
          cacheDetail = JSON.parse(oilFilterCacheString).value;
        }
        const res = cacheDetail || (await api.getModelDetail(params));
        if (
          res.code !== 0 &&
          (res.code === 40800 ||
            res.code === 40700 ||
            res.code === 40900 ||
            res.code === 40910)
        ) {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
          return;
        }
        sessionStorage.setItem(
          "oilFilterCache",
          JSON.stringify({
            key: encodeURIComponent(this.vehicle_ids.join(",")),
            value: res,
          })
        );
        this.vehicle_id =
          res.data.vehicle_list && res.data.vehicle_list[0]
            ? res.data.vehicle_list[0].id
            : this.query.id
            ? this.query.id
            : "";
        const { data } = res;
        if (data.parts_list.length === 0) {
          this.$loading.hide();
          return;
        }
        let current_parts_detail = data.parts_list.find(
          (i) => i.key === this.query.key
        ).part_detail;
        // 收集过滤器数据
        current_parts_detail.forEach((i, index) => {
          const { brandName, nickName, imageUrls, supplierCode, skuAttrList } =
            i;
          this.oil_filter_arrays.push({});
          this.oil_filter_arrays[index].basic_info = {
            brand_name: brandName, //品牌名
            nick_name: nickName, //配件名
            images: imageUrls, //图片
            supplierCode: supplierCode, //供应商编码
          };
          skuAttrList.splice(0, 3);
          let keys = [
            "高度",
            "直径",
            "内径",
            "外径",
            "螺纹尺寸",
            "垫圈外径",
            "垫圈内径",
          ];
          this.oil_filter_arrays[index].spec_info = skuAttrList.filter((i) =>
            keys.includes(i.attrName)
          );
          this.current_spec_info = this.oil_filter_arrays[0].spec_info;
        });
        // 收集多个供应商的基础信息
        this.basic_info_array = this.oil_filter_arrays.map((i) => i.basic_info);
        // console.log("多个供应商的基础信息", this.basic_info_array);
        // console.log("过滤器数据", this.oil_filter_arrays);
      } catch (error) {
        console.log("获取滤清器数据失败！", error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    // 预览图片
    preview(imgsArr, idx = 0) {
      this.$imagePreview({
        images: imgsArr,
        index: idx,
        defaultOpt: {
          fullscreenEl: false,
          arrowEl: true,
          preloaderEl: true,
          bgOpacity: 0.85,
          preload: [1, 1],
          showHideOpacity: true,
          showAnimationDuration: 0,
        },
      });
    },
    // 查询数据记录
    async queryDataRecord() {
      if (!window.localStorage.getItem("OILUSER")) {
        await setStatistics.apply(this, []);
      }
      const uuid = window.localStorage.getItem("OILUSER")
        ? Number(window.localStorage.getItem("OILUSER"))
        : "";
      const { internal_from } = this.query;

      const basic_info = {
        choose_vehicle_id: this.vehicle_ids[0],
        menu_type: 4,
        uuid: uuid,
        scheme_id: this.query.scheme_id,
        search_type:
          internal_from === "photo_vin"
            ? 2
            : internal_from === "text_vin"
            ? 3
            : 1,
      };
      await userQueryCarModelRecord.apply(this, [basic_info]);
    },
    // 返回首页
    goHome() {
      this.$router.push({
        path: "/home",
        query: {
          id: this.query.scheme_id,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.oil-filter-recommend {
  display: flex;
  flex-direction: column;
  .all-empty {
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;
    .empty-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      .empty-img {
        // margin-top: 208/100rem;
        width: 133/100rem;
        height: 133/100rem;
      }
      span {
        margin-top: 26/100rem;
        font-size: 24/100rem;
        color: #666666;
      }
    }
  }
  .model-name {
    color: #404040;
    font-size: 27/100rem;
    margin: 34/100rem auto 34/100rem 17/100rem;
  }
  .basic-info {
    // height: 401/100rem;
    touch-action: none;
    background-color: #fff;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.2);
    border-radius: 20/100rem;
    .sub-title {
      font-weight: 600;
      color: #404040;
      font-size: 27/100rem;
      margin: 26/100rem 0 24/100rem 27/100rem;
    }
    .product-info {
      display: flex;
      flex-direction: column;
      padding: 0 26/100rem;
      .img-box {
        height: 100%;
        display: flex;
        // flex-direction: column;
        align-items: center;
        overflow: hidden;
        margin-bottom: 26/100rem;
        .inner-image {
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          width: 123/100rem;
          height: 123/100rem;
          // margin-top: 34/100rem;
          // margin-bottom: 15/100rem;
          border-radius: 9/100rem;
          border: 1/100rem solid #eeeeee;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          box-shadow: 0 3/100rem 20/100rem 0 rgba(0, 0, 0, 0.05);
          .show-img {
            flex-shrink: 0;
            width: 123/100rem;
            height: 123/100rem;
            // margin-bottom: 26/100rem;
          }
        }
        .active-box {
          // border: 1px #fbce07 solid;
          // box-shadow: 0px 3px 20px 0px rgba(251, 206, 7, 0.25);
        }
        .no-img-tips {
          font-size: 14px;
          color: #404040;
        }
        .right {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 15/100rem;
          color: #333333;
          font-size: 20/100rem;
          .name,
          .spec {
            // font-weight: 300;
            // color: #404040;
            // font-size: 22/100rem;
          }
          .spec {
            margin-bottom: 10/100rem;
          }
          .active-name {
            font-weight: bold;
            // font-size: 22/100rem;
            // font-weight: 500;
            // color: #fbce07;
          }
        }
      }
    }
    .one {
      justify-content: center;
    }
    .two {
      justify-content: center;
      .img-box:first-child {
        margin-right: 15/100rem;
      }
    }
    .multiple {
      margin: 0 30/100rem;
      display: flex;
      overflow-x: scroll;
      overflow: -moz-scrollbars-none;
      -ms-overflow-style: none;
      .img-box {
        flex-shrink: 0;
        margin-right: 15/100rem;
      }
    }
    .multiple::-webkit-scrollbar {
      width: 0 !important;
    }
  }
  // 规格信息
  .spec-info {
    background-color: #fff;
    margin: 26/100rem 0 50/100rem 0;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.2);
    border-radius: 20/100rem;
    padding: 26/100rem;
    padding-bottom: 0;
    .sub-title {
      font-weight: 600;
      color: #404040;
      font-size: 27/100rem;
    }
    .list {
      .item {
        height: 85/100rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2/100rem solid #f0f0f0;
        font-size: 24/100rem;
        &:last-child {
          border-bottom: 2/100rem solid transparent;
        }
        .title {
          color: #999999;
        }
        .content {
          color: #666666;
        }
      }
    }
  }
}
</style>
